export default "__VITE_ASSET__abc246e2__"